import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';
import { DefaultArg, DefaultApiResponse } from '@libs/graphql';
import { Asset as AssetNative } from '@libs/types';

import { assetFragment } from '@libs/graphql';

export type Asset = AssetNative;

export type GetAllAssetsResponse = {
  getAllAssets: DefaultApiResponse<Asset[]>;
};

export type GetAllAssetsArgs = {
  showNativeFiat?: boolean;
};

export const getAllAssetsQuery: TypedDocumentNode<
  GetAllAssetsResponse,
  DefaultArg<GetAllAssetsArgs>
> = gql`
  query GetAllAssets($record: ShowNativeAssetsRecord) {
    getAllAssets(record: $record) {
      ...assetFields
      assetSupportedNetworks {
        id
      }
    }
  }

  ${assetFragment}
`;
